import { apiFetch } from './apiClient';

/* Histórico do cliente por setor. O backend decide quais setores a pessoa
   enxerga (admin e gerente veem todos; os demais, só o próprio), então a
   tela só renderiza o que vier em `setores`. */

export const SETORES = [
  { id: 'folha',        label: 'Folha' },
  { id: 'fiscal',       label: 'Fiscal' },
  { id: 'conformidade', label: 'Conformidade' },
  { id: 'contabil',     label: 'Contábil' },
];

export const buscarHistoricoCliente = (clienteId) =>
  apiFetch(`/clientes-historico/${clienteId}`);

export const salvarHistoricoCliente = (clienteId, setor, texto) =>
  apiFetch(`/clientes-historico/${clienteId}/${setor}`, {
    method: 'PUT',
    body: JSON.stringify({ texto }),
  });
